import React, { memo } from 'react';
import { Tooltip } from 'react-tooltip';
//interface
import { IText } from './interface';
//utils
import { generateRandomId } from 'utils/GenerateRandomId';
//components
import { Visibility } from 'components/Visibility';
//styles
import './styles.scss';

const Text: React.FC<IText> = ({ children, ...props }) => {
  const {
    size,
    className,
    fontStyle,
    width,
    color,
    textOveflow,
    minWidth,
    showTip,
    showTipContent,
    title,
    toolTipPlace,
    testId,
    as = 'p'
  } = props;

  const tooltipId = generateRandomId("ReactTooltip");

  /**
   * arrow function to define the font-size of text
   * @param size custom size
   */
  const defineFontSizeStyle = (fontSize: number) =>
    `calc(${fontSize / 1.17}px + 0.12vw)`;

  const classText = className ? ` ${className}` : '';
  const Component = as;

  return (
    <>
      <Component
        data-tooltip-content={showTip ? showTipContent || children : undefined}
        data-tooltip-id={tooltipId}
        data-tooltip-place={toolTipPlace || 'top'}
        data-type={"light"}
        className={`text-styles${classText}`}
        style={{
          fontSize: defineFontSizeStyle(size || 14),
          fontStyle: fontStyle || 'normal',
          width: width || undefined,
          color: color || undefined,
          minWidth: minWidth || undefined,
          textOverflow: textOveflow || 'ellipsis',
        }}
        title={title || ''}
        data-testid={testId}
      >
        {children}
      </Component>

      <Visibility visible={!!showTip}>
        <Tooltip id={tooltipId} variant='light' />
      </Visibility>
    </>
  );
};

export default memo(Text);
